import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { RootState } from '../store/store';
interface BreadSliderItems {
  collectionUrl:string;
  mediaUrl:string;
  name:string;
}

const BreadSlider: React.FC = () => {
  const config = useSelector((state: RootState) => state.siteConfig);
  const breadSliderItems: BreadSliderItems[] = config.topCollection;

  return (
    <section className="bread-slider is-centered card-item-image ">
      <div className="slider-container pb-2 pt-2">
        {breadSliderItems.map((item, index) => (
          <Link to={`/products?collections=${item.collectionUrl}`} key={index}> {/* Added passHref */}
            <div className="slider-item">
              <figure className="mb-2 image is-128x128 is-1by1">
                <img src={item.mediaUrl} alt={`Bread Image ${index + 1}`}/> {/* Added width and height */}
              </figure>
              <div className="is-size-7 has-text-centered has-text-weight-semibold">
                {item.name}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BreadSlider;